import local from 'packages/lib/config/config.local.json';
import staging from 'packages/lib/config/config.staging.json';
import beta from 'packages/lib/config/config.beta.json';
import prod from 'packages/lib/config/config.prod.json';
import dev from 'packages/lib/config/config.dev.json';
import { ENV, Environment } from 'packages/env';

export interface Config {
  apiHosts: {
    defaultHost: string; // for mock api
    annotationsHost: string;
    logminerHost: string;
    trainingPlatformHostOld: string;
    trainingPlatformHostEx: string;
    jobMetricsHost: string;
    drivelogsHost: string;
    blobFramesHost: string;
    techMetricsHost: string;
    dtbHost: string;
    airflowHost: string;
    userMetricsHost: string;
    taskHistoryHost: string;
    annotationsAppApi: string;
    omnitagHost: string;
  };
  GAID: string;
  auth: {
    primary: {
      client_id: string;
      redirect_uri: string;
      issuer: string;
      scope: string[];
    };
    contractor: {
      client_id: string;
      redirect_uri: string;
      issuer: string;
      scope: string[];
    };
    mobis: {
      client_id: string;
      redirect_uri: string;
      issuer: string;
      scope: string[];
    };
  };
}

const envs: { [key in Environment]: Config } = {
  test: local,
  local,
  beta,
  development: dev,
  staging,
  production: prod,
};

export const loadConfig = (): Config => {
  const config = envs[ENV];
  if (!config) {
    throw new Error(`Unable to find config for env: ${ENV}`);
  }
  return config;
};

export default envs[ENV];
